import 'css/src/components/public-pages/ThreeColumnText';

import React from 'react';
import { documentToReactComponents } from '@contentful/rich-text-react-renderer';
import type { Document } from '@contentful/rich-text-types';

import type { ImmutableMap } from 'js/src/libs/consts';

type Props = {
    data: ImmutableMap<{
        headline: string;
        cta_url: string;
        cta_text: string;
        subheading1: string;
        headline1: string;
        paragraph1: Document;
        subheading2: string;
        headline2: string;
        paragraph2: Document;
        subheading3: string;
        headline3: string;
        paragraph3: Document;
    }>;
    bgColor: string;
};

const ThreeColumnText = React.memo(function ThreeColumnText({ data, bgColor }: Props) {
    const listNodes = [];
    for (let i = 0; i < 3; i++) {
        const subheading = data.get(
            `subheading${i + 1}` as 'subheading1' | 'subheading2' | 'subheading3',
        );
        const headline = data.get(`headline${i + 1}` as 'headline1' | 'headline2' | 'headline3');
        const paragraph = data.get(
            `paragraph${i + 1}` as 'paragraph1' | 'paragraph2' | 'paragraph3',
        );

        let subheadingNode = null;
        if (subheading) {
            subheadingNode = <p className="subheading font-l5 font-l5--small">{subheading}</p>;
        }

        let headlineNode = null;
        if (headline) {
            headlineNode = <h5 className="fw-bold mb-l5-24">{headline}</h5>;
        }

        let paragraphNode = null;
        if (paragraph) {
            paragraphNode = documentToReactComponents(paragraph.toJS());
        }

        listNodes.push(
            <div className="col-sm-4" key={i}>
                {subheadingNode}
                {headlineNode}
                {paragraphNode}
            </div>,
        );
    }
    return (
        <div
            className="contentful-component three-column-text"
            style={{ backgroundColor: bgColor }}
        >
            <div className="container">
                <div className="row">
                    <div className="col-sm-12 mb-l5-48">
                        <h3 className="text-center">{data.get('headline')}</h3>
                        <h4 className="text-center">
                            <a className="subtitle-cta" href={data.get('cta_url')}>
                                {data.get('cta_text')}
                            </a>
                        </h4>
                    </div>
                </div>
                <div className="row">{listNodes}</div>
            </div>
        </div>
    );
});

export default ThreeColumnText;
